function Faq(questionElements, answerElements, options){
	if(questionElements.length){
		questionElements = [].slice.call(questionElements);
	}

	if(answerElements.length){
		answerElements = [].slice.call(answerElements);
	}

	// binds
	this.toggle = this.toggle.bind(this);
	this.onResize = this.onResize.bind(this);

	// eventDistpatcher
	this.eventDispatcher = document.createElement('div');// hacky

	this.events = {};

	try {
		this.events.questionOpened = new CustomEvent('question-opened');
	}
	catch(e){
		// To do: not tested
		this.events.questionOpened = document.createEvent('HTMLEvents');
	}

	try {
		this.events.questionClosed = new CustomEvent('question-closed');
	}
	catch(e){
		// To do: not tested
		this.events.questionClosed = document.createEvent('HTMLEvents');
	}


	this.faq = [];

	for(let i=0;i<questionElements.length;i++){
		let base = questionElements[i].nextSibling;
		let question = null;
		while(base && base.nodeType !== 1){
			base = base.nextSibling;
		}

		if(answerElements.indexOf(base) >= 0){
			question = base;
		}

		this.faq.push({
			'question' : questionElements[i],
			'answer' : question,
			'answerHeight' : question.offsetHeight
		});
	}

	for(let i=0;i<this.faq.length;i++){
		this.faq[i].question.addEventListener('click', function(event){
			if(event.currentTarget){
				this.toggle(event.currentTarget);
			}
		}.bind(this));

		this.faq[i].question.classList.add('is-closed');
		this.faq[i].answer.classList.add('is-closed');
		this.faq[i].answer.style.height = '0px';

		this.faq[i].answer.addEventListener('transitionend', function( event ){
			if(event.target.classList.contains('is-open')){
				try {
					this.eventDispatcher.dispatchEvent(this.events.questionOpened);
				}
				catch(e){
					// To do: not tested
					this.events.questionOpened.initEvent('question-opened', true, true);
				}
			}

			if(event.target.classList.contains('is-closed')){
				try {
					this.eventDispatcher.dispatchEvent(this.events.questionClosed);
				}
				catch(e){
					// To do: not tested
					this.events.questionClosed.initEvent('question-closed', true, true);
				}
			}
		}.bind(this));
	}

	window.addEventListener('resize', this.onResize);
}

Faq.prototype.toggle = function(target){
	for(let i=0;i<this.faq.length;i++){
		if(target && target == this.faq[i].question && this.faq[i].question.classList.contains('is-closed')){
			this.faq[i].question.classList.add('is-open');
			this.faq[i].question.classList.remove('is-closed');
			this.faq[i].answer.classList.add('is-open');
			this.faq[i].answer.classList.remove('is-closed');
			this.faq[i].answer.style.height = this.faq[i].answerHeight + 'px';
		}
		else {
			this.faq[i].question.classList.remove('is-open');
			this.faq[i].question.classList.add('is-closed');
			this.faq[i].answer.classList.remove('is-open');
			this.faq[i].answer.classList.add('is-closed');
			this.faq[i].answer.style.height = '0px';
		}
	}
};

Faq.prototype.onResize = function(){
	for(let i=0;i<this.faq.length;i++){
		this.faq[i].answer.style.height = 'auto';
		this.faq[i].answerHeight = this.faq[i].answer.offsetHeight;
		if(this.faq[i].answer.classList.contains('is-closed')){
			this.faq[i].answer.style.height = '0px';
		}
		else {
			this.faq[i].answer.style.height = this.faq[i].answerHeight + 'px';
		}
	}
};

export default Faq;